module.exports = "https://web-assets.ifttt.com/packs/media/docs/timeline-5d6befeb.png";